import { Enum } from './utils'

export const serviceTel = '010-59897240'

// 订单类型 1，意向单，2：服务单
export const LOCK_ORDER_TYPES = new Enum({
  INTENTION_ORDER: '意向单',
  SERVICE_ORDER: '服务单'
}, 1)

// 意向单订单状态:(0待付款 1待完善地址 2待安装 3已完成 4部分取消 5已取消)
export const LOCK_INTENTION_ORDER_STATUS = new Enum({
  PENDING_PAYMENT: '待付款',
  PANDING_PERFECT: '待完善地址',
  PANDING_INSTALLATION: '待安装',
  COMPLETED: '已完成',
  PART_CANCELLED: '部分取消',
  CANCELLED: '已取消'
}, 0)

// 服务单订单状态：-1代付款 0待审核 1代发货 2待派单 3待安装 4已完成 5已取消 6已解约 7已申请取消，审核中
export const LOCK_SERVICE_ORDER_STATUS = new Enum({
  PENDING_PAYMENT: '待付款',
  PANDING_CHECK: '待审核',
  PANDING_DELIVERY: '待发货',
  PANDING_ORDER: '待派单',
  PANDING_INSTALL: '待安装',
  COMPLETED: '已完成',
  CANCELLED: '已取消',
  RELEASE: '已解约',
  CANCEL_CHECKING: '取消审核中'
}, -1)

// 门锁意向单或服务单取消原因选择  1:地址错误,2:重复预约,3:无法安装,4:安装不及时,5:不想预约了
export const LOCK_INTENTION_ORDER_CANCEL_REASONS = new Enum({
  ADDRESS_ERROR: '地址错误',
  REPEAT_RESERVATION: '重复预约',
  NOT_INSTALL: '无法安装',
  INSTALLATION_NOT_TIMELY: '安装不及时',
  NOT_WANT_RESERVATION: '不想预约了'
}, 1)

// 门锁拼团状态（团进度）: 0：待开团 1:拼团中、2:已成团、3:拼团失败
export const LOCK_GROUP_STATUS = new Enum({
  PENDING_BEGIN_GROUP: '待开团',
  IN_THE_GROUP: '拼团中',
  COMPLETED_GROUP: '拼团成功',
  FAILURE_GROUP: '拼团失败'
}, 0)
// 门锁意向单取消状态,（1.待退款、2.部分退款、3.全额退款）
export const LOCK_INTENTION_ORDER_CANCEL_STATUS = new Enum({
  PENDING_REFUND: '待退款',
  PART_REFUND: '部分退款',
  ALL_REFUND: '全额退款'
}, 1)

// "门锁服务单取消状态"（0.未取消 1.取消审核中2.取消申请未通过3.待退款4.已全额退款5.已部分退款6.取消不退款7.未支付取消8.超时取消）
export const LOCK_SERVICE_ORDER_CANCEL_STATUS = new Enum({
  NOT_CANCEL: '未取消',
  CANCEL_CHECKING: '取消审核中',
  CANCEL_FAILED: '取消申请未通过',
  PENDING_REFUND: '待退款',
  ALL_REFUND: '全额退款',
  PART_REFUND: '部分退款',
  CANCEL_NOT_REFUND: '取消不退款',
  NOT_PAY_CANCEL: '未支付取消',
  TIME_OUT_CANCEL: '超时取消'
}, 0)

// 人工认证密码下发状态(0,"未创建人工密码"),(1,"创建成功"),(2,"下发中"),(3,"下发失败"),(4,"下发成功"),(5,"已发送短信"),(6,"无门锁,人工认证成功")
export const PWDSTATUS = new Enum({
  NO_CREATE: '未生成',
  CREATE_SUCCESS: '创建成功',
  SENDING: '下发中',
  SEND_FAIL: '下发失败',
  SEND_SUCCESS: '下发成功',
  SEND_SMS: '已发送短信',
  NO_LOCK_AUTH_SUCCESS: '无门锁,人工认证成功'
})

// 收入类型 1, "余额充值",2, "支付押金",3,"套餐购买",4,"意向单支付",
export const INCOME_TYPE = new Enum({
  BALANCE_INCOME: '余额充值',
  DEPOSIT_INCOME: '支付押金',
  TC_SERVE_INCOME: '套餐购买',
  LOCK_INTENT_INCOME: '意向单支付'
}, 1)

// 支付类型 4, "PC支付宝扫码支付",31, "PC微信扫码支付"
export const PAY_TYPE = new Enum({
  ALIPAY_PC: '支付宝',
  TENPAY_SCAN: '微信支付'
}, 1, [4, 31])

// 配送方式 配送方式：0：邮寄安装 1：带锁上门安装
export const DELIVERY_TYPE = new Enum({
  MAILING_INSTALL: '邮寄安装',
  WITH_LOCK_INSTALL: '带锁上门安装'
}, 0)

// 密码状态：0：未启用,1：启用中,3：删除中,4：启用失败,5：已过期,6：删除失败,7：已启用,10：禁用中,11：禁用失败；
export const LOCK_PASSWORD_STATUS = new Enum({
  NOTENABLE: '未启用',
  ENABLE_ING: '启用中',
  DELETE_ING: '删除中',
  ENABLED_FAIL: '启用失败',
  EXPIRED: '已过期',
  DELETE_FAIL: '删除失败',
  ENABLED: '已启用',
  DISABLE_ING: '禁用中',
  DISABLE_FAIL: '禁用失败'
}, null, [0, 1, 3, 4, 5, 6, 7, 10, 11])

// 开门人员身份类别 人员类型：1,紧急密码、2,管理员、3,保洁:4,维修、5,其他-xxx,6，旅客、7，管家
export const LOCK_PERSON_TYPE = new Enum({
  URGENTPWD: '紧急密码',
  ADMIN: '管理员',
  CLEANER: '保洁',
  REPAIR: '维修',
  OTHER: '自定义',
  PASSENGER: '旅客',
  HOUSEKEEPER: '管家'
}, 1)

// 开门事由0：全部； 1：旅客;2：保洁;3：维修;5：管家;6：店长;7：其他原因
export const LOCK_REASON_TYPE = new Enum({
  TOURIST: '旅客',
  CLEANER: '保洁',
  REPAIR: '维修',
  ADMIN: '管家',
  MANAGER: '店长',
  OTHER: '自定义'
}, 1, [1, 2, 3, 5, 6, 7])
// 解绑类型
export const LOCK_UNBIND_TYPE = new Enum({
  UNBIND: '解绑',
  BINDING: '绑定',
}, 1, [1, 2])

// 开锁方式 1,密码、2,身份证/蓝牙
export const LOCK_OPEN_WAY = new Enum({
  PASSWORD: '数字密码',
  IDCARD_OR_BLUETOOTH: '身份证/蓝牙',
  BLUETOOTH: '蓝牙'
}, 1)

// 认证单||入住单 订单状态 认证单状态编码 (1, "待入住"),(2, "入住中"),(3, "已退房"),(4, "已过期"),(5, "限制的"),(6, "待分房"),(7, "已取消")
export const AUTH_ORDER_STATUS = new Enum({
  PENDING_CHECKIN: '待入住',
  CHECKIN: '入住中',
  CHECKOUT: '已退房',
  EXPIRED: '已过期',
  LIMIT: '限制的',
  PENDING_ROOM: '待分房',
  CANCELLED: '已取消'
}, 1)

export const AUTH_ORDER_STATUS_CN = {
  1: '待入住',
  2: '入住中',
  3: '已退房',
  4: '已过期'
}

export const AUTH_ORDER_STATUS_NAME = {
  1: 'notArrived',
  2: 'checkIn',
  3: 'overtime',
  4: 'overtime'
}

// 证件类型 1-身份证;2-护照;3-港澳证;4-台胞证;
export const CARD_TYPE = new Enum({
  IDCARD: '身份证',
  PASSPORT: '护照',
  HONGKONG_PASS: '港澳居民来往内地通行证',
  TAIWAN_PASS: '台胞证'
}, 1)

// 入住单 房客上传状态： 上传状态编码 1-未上传; 2-已上传 3-部分上传;
export const AUTH_ORDER_RECORD_STATUS = new Enum({
  NO_RECORD: '未上传',
  RECORD: '已上传',
  PART_RECORD: '部分上传'
}, 1)

// 1: 房屋已上传 2:房屋未上传  2用authStatusName 1用recordStatusName
export const AUTH_ROOM_RECORD_STATUS = new Enum({
  RECORD: '房屋已上传',
  NO_RECORD: '房屋未上传'
}, 1)

export const AUTH_ORDER_RECORD_CN = {
  1: '未上传',
  2: '已上传',
  3: '部分上传'
}

// 报表类型：
export const REPORT_TYPES = new Enum({
  DAY: '以日纬度',
  MONTH: '以月纬度'
}, 1)

// 日报表选择时间范围
export const DAY_REPORT_TIME_RANGES = new Enum({
  TODAY: '今日',
  THIS_WEEK: '本周',
  THIS_MONTH: '本月',
  CUSTOMIZE_TIME: '自定义时间'
}, 1)

// 月报表选择时间范围
export const MONTH_REPORT_TIME_RANGES = new Enum({
  THIS_YEAR: '今年',
  LAST_YEAR: '去年'
}, 1)

// 预约单 房客来源 0-15 渠道来源 1: '线下客人' },{ 2: '途家网' }, { 3: '去哪儿网' },{ 4: '携程' },{ 5: '榛果' },{ 6: '小猪短租' },{ 7: '木鸟' },{ 8: '美团' },{ 9: '飞猪' },{ 10: '艺龙' },{ 11: '青芒果' },{ 12: '同程' },{ 13: 'airbnb' },{ 14: '蚂蚁短租' },{ 15: '业主自定' },{ 16: '其他' }
export const RESERVATION_ORDER_SOURCE = new Enum({
  OFFLINE_GUEST: '线下客人',
  TUJIA: '途家网',
  QUNAR: '去哪儿网',
  XIECHENG: '携程',
  ZHENGGUO: '榛果',
  XIAOZHU: '小猪短租',
  MUNIAO: '木鸟',
  MEITUAN: '美团',
  FEIZHU: '飞猪',
  YILONG: '艺龙',
  QINGMANGGUO: '青芒果',
  TONGCHENG: '同程',
  AIRBNB: 'airbnb',
  MAYI: '蚂蚁短租',
  CUSTOM: '业主自定',
  OTHER: '其他'
})

// 锁类型 1:'蓝牙锁', 2:'身份证锁', 3:'密码锁', 4:'蓝牙和身份证锁', 5:'蓝牙和密码锁', 6:'身份证和密码锁', 7:'蓝牙和身份证锁', 8: '远程开锁'
export const OPEN_MODE = new Enum({
  BLUETOOTH: '蓝牙锁',
  ID_CARD: '身份证锁',
  PASSWORD: '密码锁',
  BLUETOOTH_AND_IDCARD: '蓝牙和身份证锁',
  BLUETOOTH_AND_PWD: '蓝牙和密码锁',
  IDCARD_AND_PWD: '身份证和密码锁',
  BLUETOOTH_IDCARD_PASSWORD: '蓝牙和身份证锁',
  REMOTE: '远程开锁'
}, 1)

// 房客来源 渠道来源 0-15 颜色 1: '线下客人' },{ 2: '途家网' }, { 3: '去哪儿网' },{ 4: '携程' },{ 5: '榛果' },{ 6: '小猪短租' },{ 7: '木鸟' },{ 8: '美团' },{ 9: '飞猪' },{ 10: '艺龙' },{ 11: '青芒果' },{ 12: '同程' },{ 13: 'airbnb' },{ 14: '蚂蚁短租' },{ 15: '业主自定' },{ 16: '其他' }
export const RESERVATION_ORDER_SOURCE_COLOR = new Enum({
  OFFLINE_GUEST: '#5068EF',
  TUJIA: '#FD8238',
  QUNAR: '#00B7CE',
  XIECHENG: '#2575E3',
  ZHENGGUO: '#FFD800',
  XIAOZHU: '#DF3C54',
  MUNIAO: '#E9BF5C',
  MEITUAN: '#00C5AA',
  FEIZHU: '#FFC32F',
  YILONG: '#E60013',
  QINGMANGGUO: '#00CD67',
  TONGCHENG: '#FF6000',
  AIRBNB: '#FF596A',
  MAYI: '#51CF9D',
  CUSTOM: '#FBC958',
  OTHER: '#25E3D1'
})

export const OPENER_TYPE = [
  {
    id: 1,
    label: '旅客'
  },
  {
    id: 2,
    label: '从业人员'
  },
  {
    id: 3,
    label: '访客'
  },
  {
    id: 4,
    label: '其他'
  }
]

// 财务/订单设置收付款方式
export const FINANCE_ITEM_TYPE = {
  RECEIVE_PAYMENT: 'RECEIVE_PAYMENT', // 财务自定义
  INCOME_ITEM: 'INCOME_ITEM', // 收入项目
  EXPENDITURE_ITEM: 'EXPENDITURE_ITEM', // 支出项目
  CHANNEL_SOURCE: 'CHANNEL_SOURCE' // 订单自定义
}

// 财务/订单设置收付款方式
export const FINANCE_ITEM_TYPE_CN = {
  1: '收取房费',
  2: '收取押金',
  100: '退还房费',
  101: '退还押金'
}

// 新建订单财务默认 收支项
export const FINANCE_ITEM_DEFAULT_IDS = new Enum({
  INCOME_ROOMRATE: '收取房费',
  INCOME_DEPOSIT: '收取押金',
  RETURN_ROOMRATE: '退还房费',
  RETURN_DEPOSIT: '退还押金'
}, null, [1, 2, 100, 101])
export const AB_ACTION_MODEL_STATUS = new Enum({
  CHECK: '查看订单',
  MODIFY: '修改订单',
  HANDOUT: '去分房'
}, 1)

// 后端密码设置路径
export const PWD_BUSINESS_TYPE = {
  OP_TEXT_PWD: 1, // 操作普通数字密码
  MANUAL_AUTH: 3, // 人工认证
  OP_ORDER: 5 // 操作入住单
}

// 密码设置-密码状态
export const PWD_SETTING_STATUS = new Enum({
  NO_CREATE: '未生成',
  ENBLE: '下发中',
  DISABLE: '禁用中',
  ENABLE_SUC: '已生效',
  DISABLE_SUC: '已失效',
  OVERDUE: '已过期',
  ENA_FAIL: '下发失败',
  DEL: '删除中',
  DEL_SUCC: '删除成功',
  DEL_FAIL: '删除失败',
  DISABLE_FAIL: '禁用失败'
})

// 订单数据来源
export const ORDER_DATA_ORIGIN = new Enum({
  APP: 'APP 创建',
  PMS_PC: 'PMS PC 创建',
  AIRBNB_API: 'AirBnb 接口同步',
  XIAOZHU_API: '小猪接口同步',
  XIAOZHU_PC: '小猪PC同步',
  MEITUAN_PC: '美团PC同步',
  TUJIA: '途家同步',
}, 1)

export const LOCK_TYPE = {
  NB_LOCK: 5,
  SECOND_LOCK: 3
}

// 协议类型（前端自定义）
export const AGREEMENT_TYPE = {
  SERVICE: 1,
  PRIVACY: 2
}

// 权限
export const PERMISSONS = [
  { name: '全部权限', value: 1001 },
  { name: '房态管理', value: 1002 },
  { name: '订单管理', value: 1007 },
  { name: '门锁管理', value: 1003 },
  { name: '财务管理', value: 1008 },
  { name: '房源管理', value: 1009 },
  { name: '渠道直连', value: 1010 },
  { name: '设置', value: 1011 },
  { name: '房务', value: 1012 },
  { name: '房价', value: 1013 },
]
